"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { GroqImage } from "@/helpers/Image";

import { PortableText } from "@portabletext/react";
import {
  customRichTextComponent,
  richTextComponent,
} from "@/sanity/sanityPortableText";

import { CTAButton } from "@/shadcn/ui/button";

import type { PageAffiliateSchema } from "@/sanity/pages/PageAffiliateTemplate";
import Chip from "@/components/global/ui/Chip";
import { resolveAffiliateRules } from "@/lib/affiliateGlobalSections";

export default function Rules({ data }: { data: PageAffiliateSchema }) {
  const rules = resolveAffiliateRules(data);

  return (
    <section
      id="rules"
      className="w-full h-full lg:px-0 py-[8rem] px-[2rem] lg:py-[15rem]"
    >
      <div className="relative mx-auto w-full">
        <div className="flex relative flex-col mx-auto w-full lg:items-center z-[1]">
          {rules.chip && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            >
              <p className="italic text-black font-blacker mb-[1.5rem]">
                {rules.chip}
              </p>
            </motion.div>
          )}
          <motion.div
            className="richtext richtext-start lg:richtext-center prose-p:text-[2rem] lg:prose-p:text-[2rem] prose-em:italic prose-em:font-blacker prose-headings:mb-[2rem]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            {rules.text && (
              <PortableText
                value={rules.text}
                components={richTextComponent}
              />
            )}
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-[1rem] mt-[3rem] lg:mt-[4rem] w-[min(160.5rem,100%)]">
            {rules.items.map((item, index) => (
              <motion.div
                key={index}
                className="relative"
                initial={{ opacity: 0, y: 20, filter: "blur(10px)" }}
                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{
                  duration: 0.25,
                  delay: index * 0.08,
                  ease: [0.22, 0.61, 0.36, 1],
                }}
              >
                <div className="flex items-center h-full border gap-[2.75rem] rounded-[.5rem] p-[1rem] border-black/[14%] lg:p-[2rem]">
                  {item.icon && (
                    <GroqImage
                      src={item.icon}
                      alt="icon"
                      className="w-[7.25rem] h-[7.25rem] min-w-[7.25rem] min-h-[7.25rem]"
                    />
                  )}
                  <div className="">
                    <p className="text-black/80 text-[2rem] leading-[140%]">
                      {item.text}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/*<motion.div
            className="mx-auto w-full mt-[4rem] lg:w-fit lg:mt-[6rem]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <CTAButton data={data.rulesCta} />
          </motion.div>*/}
        </div>
      </div>
    </section>
  );
}
